// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3wxyn","footer":"ModalError_footer__35FcG"};